package org.hs_soft.runmynesto.pages.home.sub_page.user.component.tabs.general_tab

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.jetbrains.compose.web.attributes.InputType

@Composable
fun UserInfoDetail(
    name: String,
    printName: String,
    shortName: String,
    password: String,
    isActive: Boolean,
    passwordVisible: Boolean,
    onVisiblePassClick: () -> Unit,
    updateNameValue: (String) -> Unit,
    updatePrintNameValue: (String) -> Unit,
    updatePasswordValue: (String) -> Unit,
    updateActivityValue: (Boolean) -> Unit,
    updateShortNameValue:(String)->Unit,

)
{
    Column()
    {

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().name,
            value = name,
            isRequired = false,
            hint ="",
            isOutlinedEditText = true,
            onFocusIn = {},
            onFocusOut = {
                 updateNameValue(it)
            },
            onInputChange = {it, validation ->

            },
        )


        CustomEditText(
            modifier = Modifier.margin(right = Dimen.extraLargePadding),
            label = Strings.current().printName,
            value = printName,
            isRequired = false,
            hint ="",
            isOutlinedEditText = true,
            onFocusIn = {},
            onFocusOut = {updatePrintNameValue(it)},
            onInputChange = {it, validation ->

            },
        )

        CustomEditText(
            modifier = Modifier.margin(right = Dimen.extraLargePadding),
            label = Strings.current().shortName,
            value = shortName,
            isRequired = false,
            hint ="",
            isOutlinedEditText = true,
            onFocusIn = {},
            onFocusOut = {updateShortNameValue(it)},
            onInputChange = {it, validation ->

            },
        )

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().password,
            value = password,
            endIconPath =if(passwordVisible) Res.PathIcon.hideEye else Res.PathIcon.showEye,
            isRequired = false,
            inputType = if(passwordVisible) InputType.Text else InputType.Password,
            hint ="",
            isOutlinedEditText = true,
            onFocusIn = {},
            onFocusOut = {updatePasswordValue(it)},
            onEndIconClick = {
              onVisiblePassClick()
            },
            onInputChange = {it, validation ->

            },
        )


        CheckboxComponent(
            modifier = Modifier
                .margin(
                    top= Dimen.mediumPadding,
                ),
            checkStatus = isActive,
            title = Strings.current().activate,
            onChecked = {
                updateActivityValue(true)
            },
            onUnChecked = {
                updateActivityValue(false)
            },
            accentColor = Theme.PrimaryMain.rgb
        )



    }



}

